import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useNavigate } from "react-router-dom"
import GoBack from "../../../subsidiary/GoBack/GoBack"
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import styles from './Sms.module.css'
import Button from '@mui/material/Button'
import { useDispatch, useSelector } from 'react-redux'
import { changePhone, getUserData } from "../../../Profile/profileSlice"
const Sms = () => {
    const [code, setCode] = useState(null)
    const dispatch = useDispatch()
    const navigation = useNavigate()
    const phoneNumber = useSelector(state => state.loginSlice.phoneNumber)
    const submitHandler = () => {
        dispatch(changePhone({ phoneNumber, code })).then((params) => {
            if (!params.error) {
                dispatch(getUserData())
                window.showAlert({ title: 'Номер изменен успешно', type: 'success' })
                navigation('/profile')
            }
            else {
                window.showAlert({ title: 'Код не подходит, попробуйте еще раз', type: 'warning' })
            }
        })
    }
    useEffect(() => {
        window.showAlert({ title: 'Сейчас вам поступит звонок, потребуется ввести последние 4 цифры номера', type: 'success' })
    }, [])
    return (
        <section className={'main'}>
            {<>
                <GoBack text='Назад' />
                <div className="content-wrapper">
                    <div className="page-title-container">
                        <h1 className="page-title ">
                            Подтверждение
                        </h1>
                    </div>
                    <div>
                        <FormControl className={styles.formCtrl} >
                            <>
                                <TextField value={code} onChange={(e) => { setCode(e.target.value) }} type='number' error label={`Введите последние 4 цифры номера`} placeholder={'****'} variant="outlined" />
                            </>
                            <Button onClick={submitHandler} className={styles.sendBtn} variant="contained">Отправить</Button>
                        </FormControl>
                    </div>
                </div>
            </>}
        </section>
    )
}
export default Sms
